module.exports = __webpack_public_path__ + "static/img/defaultImg.b297072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/defaultImg.png
// module id = Z+lF
// module chunks = 66